module.exports = __webpack_public_path__ + "static/twitter-471c80dd2e1fdb938d6b7c193c613d0f.png";